<template>
    <div style="display: contents;">
        <slot v-if="componentEnabled"
              :attachGet="getPopperEl"
              :menuProps="{
                transition: 'popper-scale-vertical',
                contentClass: 'menu-rounded menu-max-width-screen'
            }"
        />
        <portal selector="#app">
            <div
                ref="popper"
                :class="{'popper-menu-hide-under-navbar': !popupUsedInModal}"
                class="popper-menu-anchor"
                v-bind="$attrs"
                v-on="$listeners">
            </div>
        </portal>
    </div>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal';
import popperPositionedVuetifySelectMixin from '../../mixins/popperPositionedVuetifySelectMixin';

export default {
    components: { Portal },
    mixins: [popperPositionedVuetifySelectMixin],
    props: {
        vuetifyComponentRefGet: Function,
        popupUsedInModal: Boolean
    },
    methods: {
        getReferenceEl() {
            return this.vuetifyComponentRefGet().$el;
        },
        getPopperEl() {
            return this.$refs.popper;
        },
        getVMenuEl() {
            return this.getPopperEl();
        }
    }/*,
    async mounted() {
        // Await two ticks, one for portal to mount and one for component to render in portal
        await this.$nextTick();
        await this.$nextTick();
        console.log('vuetifyComponentRefGet()', this.vuetifyComponentRefGet())
        console.log('getReferenceEl()', this.getReferenceEl())
        console.log('getPopperEl()', this.getPopperEl())
    }*/
};
</script>

